module.exports = __webpack_public_path__ + "static/pic17-1650b1da43cdf43367a9ef99072e0ebd.png";